import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
		this.body = document.querySelector('body'); // Corregido: 'this.body'
	}

	init() {
		const button = this.el;
		const header = document.querySelector('header');
		const nav = document.querySelector('.theme-nav');

		button.addEventListener('click', () => {
			let isExpanded = button.getAttribute('aria-expanded') === 'true'; // Corrige la comparación
			button.setAttribute('aria-expanded', !isExpanded); // Invierte el estado
			isExpanded = button.getAttribute('aria-expanded') === 'true'; // Actualiza el estado
			nav.classList.toggle('open', isExpanded);
			header.classList.toggle('open', isExpanded);
			this.body.classList.toggle('no-scroll', isExpanded); // Corregido: 'this.body'

			if (isExpanded) {
				this.hideScroll();
			} else {
				this.showScroll();
			}
		});
	}

	// Función para ocultar el scroll y guardar la posición
	hideScroll() {
		/* this.body.dataset.scrollPosition = window.scrollY;
		this.body.style.overflow = 'hidden';
		this.body.style.position = 'fixed';
		this.body.style.top = `-${window.scrollY}px`; */
	}

	// Función para mostrar el scroll y restaurar la posición
	showScroll() {
		const scrollPosition = this.body.dataset.scrollPosition; // Corregido: 'this.body'
		this.body.style.overflow = '';
		this.body.style.position = '';
		this.body.style.top = '';
		window.scrollTo(0, Number(scrollPosition)); // Asegúrate de convertir a número
	}
}
